import { LocalNotifications } from 'Capacitor/@capacitor/local-notifications'
import { Notify, Platform } from 'quasar'
import { boot } from 'quasar/wrappers'
import { i18n } from './i18n'
const { t } = i18n.global

export default boot(async () => {
  if (!Platform.is.capacitor) return
  const permission = await LocalNotifications.checkPermissions()
  if (permission.display !== 'granted') {
    const permission = await LocalNotifications.requestPermissions()
    if (permission.display !== 'granted') {
      Notify.create({
        message: t('notification.permissiondenied'),
        color: 'warning'
      })
    }
  }
})

export { LocalNotifications }
